document.addEventListener('DOMContentLoaded', () => {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('dryll-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  const elementsToAnimate = document.querySelectorAll('.shopify-section, img:not(.no-reveal), .text-block, h1, h2, h3, p');
  
  if (!window.location.pathname.includes('/products/')) {
    elementsToAnimate.forEach(el => {
    // Skip animation for carousel items, text boxes (due to overflow hidden clipping), marquees, and their children
    if (el.closest('[class*="ai-regeneration-grid"]') || 
        el.closest('[class*="ai-ingredients-grid"]') || 
        el.closest('[class*="ai-regeneration-item"]') || 
        el.closest('[class*="ai-ingredients-item"]') ||
        el.closest('[class*="ai-text-box-container"]') ||
        el.closest('marquee-component') ||
        el.tagName.toLowerCase() === 'marquee-component' ||
        el.closest('header') ||
        el.closest('.header') ||
        el.closest('sticky-header') ||
        el.closest('.shopify-section-group-header-group') ||
        el.closest('[id*="header"]') ||
        el.closest('footer') ||
        el.closest('.footer') ||
        el.closest('.shopify-section-group-footer-group') ||
        el.closest('[id*="footer"]')) {
      return;
    }

    if (!el.classList.contains('no-reveal')) {
      el.classList.add('dryll-reveal');
      observer.observe(el);
    }
  });
  }

  // Mobile Carousel Scale Effect (Revolut Style)
  const updateMobileCarousel = () => {
    if (window.innerWidth > 768) {
       document.querySelectorAll('div[class*="ai-regeneration-item"]').forEach(item => {
           item.style.transform = '';
           item.style.opacity = '';
           item.style.transition = '';
       });
       return;
    }
    
    const carousels = document.querySelectorAll('div[class*="ai-regeneration-grid"]');
    carousels.forEach(carousel => {
      const carouselRect = carousel.getBoundingClientRect();
      const carouselCenter = carouselRect.left + carouselRect.width / 2;
      
      let closestItem = null;
      let minDistance = Infinity;
      
      const items = carousel.querySelectorAll('div[class*="ai-regeneration-item"]');
      items.forEach(item => {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.left + rect.width / 2;
        const distance = Math.abs(carouselCenter - itemCenter);
        if (distance < minDistance) {
          minDistance = distance;
          closestItem = item;
        }
      });
      
      items.forEach(item => {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.left + rect.width / 2;
        
        if (item === closestItem) {
          item.style.transformOrigin = 'center center';
          item.style.transform = 'scale(1)';
          item.style.opacity = '1';
        } else {
          if (itemCenter > carouselCenter) {
             item.style.transformOrigin = 'left center';
          } else {
             item.style.transformOrigin = 'right center';
          }
          item.style.transform = 'scale(0.85)';
          item.style.opacity = '0.6';
        }
        item.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.3s ease';
      });
    });
  };

  const carousels = document.querySelectorAll('div[class*="ai-regeneration-grid"]');
  carousels.forEach(carousel => {
    carousel.addEventListener('scroll', updateMobileCarousel, { passive: true });
  });
  window.addEventListener('resize', updateMobileCarousel);
  setTimeout(updateMobileCarousel, 100);
});
